export default __webpack_public_path__ + "static/digitalforms-ee894b0b665ba44b5a8e0c05ea2fd091.png";